import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faChevronRight,
    faExclamationCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { faLightbulbOn } from '@fortawesome/pro-solid-svg-icons';

import { TvPlanContext } from "../../contexts/tvplancontext";
import Price from "../Price";
import './index.css';


function TvReview(props) {
    const { t, i18n } = useTranslation('tvplan');
    const lang = i18n.language === 'fr' ? 'fr' : "en";
    const ctx = useContext(TvPlanContext);
    const org = ctx.getOrg();
    const [ sending, setSending] = useState(false);
    const gutter = 10;
    const colSize = {
        xs: 17,
        sm: 19,
        md: 20,
    };
    const colSizePrice = {
        xs: 7,
        sm: 5,
        md: 4,
    };

    let plan = ctx.getStarterPlan();
    let checklist = ctx.getChecklist();
    let total = ctx.getTotal();
    let selData = ctx.getSelData();
    let tvPlanId = ctx.getTvPlanId();
    let webview = ctx.getWebview();
    let urlReferrer = ctx.urlReferrer;
    let signUpUrl = process.env.REACT_APP_SIGNUP_URL || "";
    let signUpUrlFA = process.env.REACT_APP_SIGNUP_URL_FA || "";

    if (org === 'fa' && signUpUrlFA !== "") {
        signUpUrl = signUpUrlFA;
    }

    const onReset = () => {
        Modal.confirm({
            title: t('Are you sure?'),
            content: t('TvPlanStep4.modal_content'),
            okText: t('Reset'),
            okButtonProps: { type: 'primary' },
            cancelText: t('Cancel'),
            onOk: () => ctx.resetSelection(),
        });
    };

    const confirmGo = async() => {
        setSending(true);
        let modalError = {
            title: t('TvPlanStep4.form_error_title'),
            content: t('TvPlanStep4.form_error_content'),
        };

        if (plan != null && plan.apiCode !== "" && checklist.length > 0) {
            let error = false;

            for (let chk of checklist) {
                if (chk.error) {
                    error = true;

                    if (chk.error_message) {
                        modalError = {
                            title: chk.error_message,
                            content: t('tvreview_error_pickpack_content'),
                        };
                    }
                    break;
                }
            }

            if (!error) {
                let response = await ctx.apiFetch('tvplan/create', {
                    des: plan.des,
                    desFr: plan.desFr,
                    planPrice: total,
                    jdata: JSON.stringify({
                        plan: plan,
                        selData: selData
                    })
                }, 'set');

                if (response != null && response.success) {
                    tvPlanId = parseInt(response.data.id) || 0;
                    tvPlanId = isNaN(tvPlanId) ? 0 : tvPlanId;

                    if (tvPlanId > 0) {
                        window.location = `${signUpUrl}${org}?planApiCode=${plan.apiCode}&tvPlanId=${tvPlanId}&lang=${lang}`;
                        return true;
                    }
                }
            }
        }

        Modal.error(modalError);
        setSending(false);
        return false;
    };
    const confirmUpdate = async(path) => {
        setSending(true);
        let modalError = {
            title: t('TvPlanStep4.form_error_title'),
            content: t('TvPlanStep4.form_error_content'),
        };

        if (tvPlanId > 0) {
            let error = false;

            for (let chk of checklist) {
                if (chk.error) {
                    error = true;

                    if (chk.error_message) {
                        modalError = {
                            title: chk.error_message,
                            content: t('tvreview_error_pickpack_content'),
                        };
                    }
                    break;
                }
            }

            if (!error) {
                let response = await ctx.apiFetch(path, {
                    des: plan.des,
                    desFr: plan.desFr,
                    planPrice: total,
                    jdata: JSON.stringify({
                        plan: plan,
                        selData: selData
                    })
                }, 'set');

                if (response != null && response.success) {
                    window.location = urlReferrer;
                    return true;
                }
            }
        }

        Modal.error(modalError);
        setSending(false);
        return false;
    };

    let tipRow = null;

    if (props.showGroupTip) {
        tipRow = (
            <li key="tvplan-review-tip" style={{borderBottom:0}}>
                <Row gutter={gutter}>
                    <Col style={{textAlign: 'right'}}>
                        <div className='review-tip' style={{textAlign: 'center'}}>
                            <FontAwesomeIcon className="review-tip-icon" icon={faLightbulbOn} />&nbsp;
                            {t('tip_astuce', {channels: props.pickMoreForDiscountCount, req: props.groupCount})}
                        </div>
                    </Col>
                </Row>
            </li>
        );
    }

    return (
        <div className="tv-plan-review">
            <div className='tv-plan-review-list'>
                <ul>
                    {checklist.map((item, index) => {
                        let iservices = [];

                        if (Array.isArray(item.servicesDes) && item.servicesDes.length > 0) {
                            iservices = item.servicesDes;
                        }
                        else if (Array.isArray(item.services) && item.services.length > 0) {
                            iservices = item.services;
                        }

                        let svcs = iservices.join(", ");

                        return (
                            <li key={`tvplan-review-fav-${index}`}>
                                <Row gutter={gutter}>
                                    <Col {...colSize} className="col-cnt-left">
                                        {item.error ? (
                                        <FontAwesomeIcon
                                            className="checklistcheck faierror"
                                            icon={faExclamationCircle}
                                        />
                                        ) : (
                                        <FontAwesomeIcon
                                            className="checklistcheck fai"
                                            icon={faCheckCircle}
                                        />
                                        )}
                                        <div className="checklistleft">
                                            {item.des}
                                            {item.des_error && (
                                            <span style={{marginLeft: 12, color: 'red'}}>({item.des_error})</span>
                                            )}
                                        </div>
                                        <div className="checklistservices">{svcs}</div>
                                    </Col>
                                    <Col {...colSizePrice} className="col-cnt-right">
                                        <span>{(item.price > 0)? (<Price>{item.price}</Price>): null}</span>
                                    </Col>
                                </Row>
                            </li>
                        );
                    })}
                    <li key="tvplan-review-total" style={{borderBottom:0}}>
                        <Row gutter={gutter}  justify="end" style={{padding:5}}>
                            <Col {...colSize} className="tvplan-review-total-label col-cnt-left">
                                <span>{t('Add-on Total')} : </span>
                            </Col>
                            <Col {...colSizePrice} className="tvplan-review-total col-cnt-right">
                                <Price>{total}</Price>
                            </Col>
                        </Row>
                    </li>
                    {tipRow}
                    <li key="tvplan-review-reset" style={{borderBottom:0}}>
                        <Row gutter={gutter}>
                            <Col style={{textAlign: 'right'}}>
                                <Button onClick={onReset}>{t('Reset Selection')}</Button>
                            </Col>
                        </Row>
                    </li>
                </ul>
                <br />
                <div className="confirm-button-div">
                    {webview === "subapp" && (
                    <Button
                        type="primary"
                        onClick={() => confirmUpdate(`portal/tvplan/${tvPlanId}/modifyselection`)}
                        loading={sending}>
                        {t(sending ? 'Please Wait' : 'Confirm My Selection')}
                        <FontAwesomeIcon className="confirm-button-icon" icon={faChevronRight} />
                    </Button>
                    )}
                    {webview === "admin" && (
                    <Button
                        type="primary"
                        onClick={() => confirmUpdate(`tvplan/${tvPlanId}/updatetvplan`)}
                        loading={sending}>
                        {t(sending ? 'Please Wait' : 'Update TV Plan')}
                        <FontAwesomeIcon
                            className="confirm-button-icon"
                            icon={faChevronRight} />
                    </Button>
                    )}
                    {webview === "choose" && (
                    <Button
                        type="primary"
                        onClick={confirmGo}
                        loading={sending}>
                        {t(sending ? 'Please Wait' : org === "fa" ? 'Confirm My Selection' : 'Proceed to Sign-Up')}
                        <FontAwesomeIcon
                            className="confirm-button-icon"
                            icon={faChevronRight} />
                    </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default TvReview;
